import * as request from '@/utils/request'

export default {
// --------------------------------------  商品管理 -------------------------------------------
  /**
   * @description 获取商品分类列表
   * @author YM
   * @date 2019-03-07
   */
  getGoodsCategoryList() {
    return request.post('/goods/category_list')
  },
  /**
   * @description 获取商品列表
   * @author YM
   * @date 2019-02-01
   * @param {*} data
   * @returns 
   */
  getGoodsList(data) {
    return request.post('/goods/list', data)
  },
  /**
   * @description 商品保存
   * @author YM
   * @date 2019-02-06
   * @param {*} data
   * @returns 
   */
  saveGoods(data) {
    return request.post('/goods/store', data)
  },
  /**
   * @description 获取商品详情
   * @author YM
   * @date 2019-02-11
   * @param {*} id
   * @returns 
   */
  getGoodsInfo(id) {
    let data = {id:id}
    return request.post('/goods/get_info', data)
  },
  /**
   * @description 根据id删除单条信息
   * @author YM
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  deleteGoods(id) {
    let data = {id:id}
    return request.post('/goods/delete',data)
  },
  /**
   * @description 检索规格信息
   * @author YM
   * @date 2020-05-10
   * @param {*} data
   * @returns 
   */
  searchGoodsSpecNameValue(data) {
    return request.post('/goods/search_spec_info',data)
  },
  /**
   * @description 增加商品规格信息
   * @author YM
   * @date 2020-05-10
   * @param {*} data
   * @returns 
   */
  addGoodsSpecInfo(data) {
    return request.post('/goods/add_spec_info',data)
  }
}